import { render, staticRenderFns } from "./OrganizationListTable.vue?vue&type=template&id=90c3b77c&"
import script from "./OrganizationListTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports